import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

/**
 * Dados ATUAIS da carteira Claro para um CNPJ, vindos da ÚLTIMA importação
 * da página Carteira (carteira_claro_empresas). Fonte de verdade que o usuário
 * atualiza ao subir o relatório da Claro — não "congela" como o campo do lead.
 */
export interface CarteiraClaroAtual {
  tempo_contrato_voz: number | null;
  qtd_linhas_voz: number | null;
  classificacao: string | null;
  semana_referencia: string | null;
}

export function useCarteiraClaroAtual(cnpj?: string | null) {
  const cnpjLimpo = cnpj ? String(cnpj).replace(/\D/g, '') : '';
  return useQuery<CarteiraClaroAtual | null>({
    queryKey: ['carteira-claro-atual', cnpjLimpo],
    queryFn: async () => {
      if (!cnpjLimpo) return null;
      const { data, error } = await supabase.rpc('get_carteira_claro_atual', { p_cnpj: cnpjLimpo });
      if (error) throw error;
      return Array.isArray(data) && data.length > 0 ? (data[0] as CarteiraClaroAtual) : null;
    },
    enabled: !!cnpjLimpo,
    staleTime: 5 * 60 * 1000,
    gcTime: 15 * 60 * 1000,
  });
}
